<form edlFocusTrap [formGroup]="form" (ngSubmit)="ok(form)" novalidate>
    <div class="modal-header">
        <h4 class="modal-title">Reassign Approval Stage</h4>
    </div>
    <div class="modal-body">
        <p>Please select the approver you wish to reassign the current approval stage to.</p>
        <div class="row">
            <div class="col-sm-12">
                <div class="alert alert-primary mt-3" role="info">
                    <div class="form-group">
                        <label for="reassignStageUser" class="form-label">{{ verificationStage.StageName }}</label>
                        <select id="reassignStageUser" class="form-select" formControlName="SelectedUser">
                            <option [value]="TargetEvaluator.ALL">All</option>
                            <option *ngFor="let approver of verificationStage.Approvers" [value]="approver.UserID">{{ approver.DisplayName }}</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="submit" class="btn btn-primary">Ok</button>
        <button type="button" class="btn btn-info" (click)="cancel()">Cancel</button>
    </div>
</form>